function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.43959 20.047c0-10.802 8.77-19.572 19.572-19.572 10.84 0 19.572 8.77 19.572 19.572 0 10.84-8.7323 19.572-19.572 19.572-10.802 0-19.572-8.7323-19.572-19.572z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.43959 20.047c0-10.802 8.77-19.572 19.572-19.572 10.84 0 19.572 8.77 19.572 19.572 0 10.84-8.7323 19.572-19.572 19.572-10.802 0-19.572-8.7323-19.572-19.572",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m6.5538 15.345h16.542l4.3989 4.5448 0.0356 8.6979c-2.1226 7.22e-4 -15.986-0.04553-20.773-0.0084z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m28.096 19.889h-4.4275v-4.5448z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m27.575 19.752h-4.206v-4.2144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93857
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.5649 28.592 0.0356-13.146h16.641l4.4252 4.4371 0.02432 8.6983",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98085
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.663 28.572h21.197",
  strokeWidth: "1px"
}));
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m9.5107 12.373h16.542l4.3989 4.5448 0.0356 8.6979c-2.1226 7.22e-4 -15.986-0.04553-20.773-0.0084z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m31.053 16.918h-4.4275v-4.5448z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m30.532 16.78h-4.206v-4.2144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93857
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.5217 25.621 0.0356-13.146h16.641l4.4252 4.4371 0.02432 8.6983",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98085
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.6198 25.601h21.197",
  strokeWidth: "1px"
}));
var _ref0 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m12.497 9.1725h16.542l4.3989 4.5448 0.0356 8.6979c-2.1226 7.22e-4 -15.986-0.04553-20.773-0.0084z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref1 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m34.039 13.717h-4.4275v-4.5448z"
}), React.createElement("path", {
  d: "m19.491 12.747c0-0.15572 0.16511-0.31143 0.33021-0.31143h10.154c0.16511 0 0.30269 0.15572 0.30269 0.31143v1.1679c0 0.15572-0.13759 0.28548-0.30269 0.28548h-10.154c-0.16511 0-0.33021-0.12977-0.33021-0.28548z"
}), React.createElement("path", {
  d: "m15.19 13.297c0-0.5681 0.506-1.073 1.0752-1.073 0.60088 0 1.0752 0.50497 1.0752 1.073 0 0.59966-0.47438 1.073-1.0752 1.073-0.56926 0-1.0752-0.47341-1.0752-1.073z"
}), React.createElement("path", {
  d: "m19.491 17.969c0-0.13702 0.1677-0.27404 0.3354-0.27404h10.314c0.1677 0 0.30745 0.13702 0.30745 0.27404v1.0277c0 0.13702-0.13975 0.2512-0.30745 0.2512h-10.314c-0.1677 0-0.3354-0.11419-0.3354-0.2512z"
}), React.createElement("path", {
  d: "m15.19 18.556c0-0.5681 0.506-1.073 1.0752-1.073 0.60088 0 1.0752 0.50497 1.0752 1.073 0 0.59966-0.47438 1.073-1.0752 1.073-0.56926 0-1.0752-0.47341-1.0752-1.073z"
}));
var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  className: "icon-tertiary"
}, React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m19.502 12.801c0-0.17286 0.17102-0.34492 0.34204-0.34571l9.433-0.04323c0.0075 0.26724 0.01217 1.0884-3.5e-5 1.3225 0.2244 0.01791 1.1606-0.09954 1.3543-0.09272l0.04415 0.4556c0.01667 0.17206-0.14252 0.3169-0.31353 0.3169h-10.518c-0.17102 0-0.34204-0.14405-0.34204-0.3169z"
}), React.createElement("path", {
  d: "m15.167 13.406c0-0.60966 0.54303-1.1516 1.154-1.1516 0.64485 0 1.154 0.54192 1.154 1.1516 0 0.64354-0.50909 1.1516-1.154 1.1516-0.6109 0-1.154-0.50805-1.154-1.1516"
}), React.createElement("path", {
  d: "m19.583 17.784c0-0.16789 0.16787-0.33577 0.33574-0.33577h10.324c0.16787 0 0.30776 0.16789 0.30776 0.33577v1.2591c0 0.16789-0.13989 0.30779-0.30776 0.30779h-10.324c-0.16787 0-0.33574-0.1399-0.33574-0.30779z"
}), React.createElement("path", {
  d: "m15.174 18.42c0-0.62006 0.55228-1.1712 1.1736-1.1712 0.65584 0 1.1736 0.55116 1.1736 1.1712 0 0.6545-0.51777 1.1712-1.1736 1.1712-0.62132 0-1.1736-0.51671-1.1736-1.1712"
})), React.createElement("path", {
  d: "m33.518 13.58h-4.206v-4.2144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93857
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.508 22.42 0.0356-13.146h16.641l4.4252 4.4371 0.02432 8.6983",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.98085
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.606 22.4h21.197",
  strokeWidth: "1px"
}));
var SvgSurveyModelTabPulse = function SvgSurveyModelTabPulse(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabPulse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Pulse.0d712e3b.svg";
export { ForwardRef as ReactComponent };